module.exports = __webpack_public_path__ + "static/media/gallery-4-5.fa9caa8a.png";